/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientIngredientTypename = "PatientIngredient" as const;

/**
 *
 * @export
 * @interface PatientIngredient
 */
export interface PatientIngredient {
  /**
   *
   * @type {string}
   * @memberof PatientIngredient
   */
  english?: string;
  /**
   *
   * @type {string}
   * @memberof PatientIngredient
   */
  japanese?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientIngredient
   */
  readonly __typename?: string;
}

export function PatientIngredientFromJSON(json: any): PatientIngredient {
  return PatientIngredientFromJSONTyped(json, false);
}

export function PatientIngredientFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientIngredient {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientIngredientTypename,

    english: !exists(json, "english") ? undefined : json["english"],
    japanese: !exists(json, "japanese") ? undefined : json["japanese"],
  };
}

export function PatientIngredientToJSON(object?: PatientIngredient | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    english: value.english,
    japanese: value.japanese,
  };
}
